<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">商品中心</el-breadcrumb-item>
            <el-breadcrumb-item>商品编辑</el-breadcrumb-item>
        </el-breadcrumb>
        <el-container>
            <el-main style="overflow: auto;height: calc(100vh - 80px);">
                <el-form label-width="150px" :model="editFormVo"  :rules="editFormRules"  ref="editFormVo" >
                  <div style="padding-bottom: 10px; width: 100%; margin-bottom: 13px; border-bottom: 2px solid;color: #333333">
                    <h1>基础设置</h1>
                  </div>
                  <el-form-item label="商品名称" prop="name">
                      <el-input placeholder="商品名称" size="small" style="width: 400px;"
                                v-model="editFormVo.name"></el-input>
                  </el-form-item>

                  <el-form-item label="所属展会" prop="exhibitionId" v-if="editFormVo.id != ''">
                    <el-select v-model="editFormVo.exhibitionId" placeholder="请选择">
                      <el-option
                        v-for="item in exhList"
                        :key="item.id"
                        :label="item.exhibitionName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="所属大类" prop="typeId">
                    <el-select v-model="editFormVo.typeId" placeholder="请选择"  @change="clearParId()" style="height: 33px;width: 250px;">
                      <el-option
                        v-for="item in typeSelect"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="分类名称" prop="parentId" v-if="editFormVo.id != ''">
                    <el-select v-model="editFormVo.parentId"  placeholder="请选择">
                      <el-option
                        v-for="item in comList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"  v-if="item.type == editFormVo.typeId && item.status == 0 && item.exhibitionId == editFormVo.exhibitionId">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <div v-if="editFormVo.id == ''">
                    <el-form>
                      <el-table :data="editFormVo.zhList" style="width: 50%; margin-left: 140px">
                        <el-table-column prop="exhibitionId" label="所属展会">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.exhibitionId" placeholder="请选择">
                              <el-option
                                v-for="item in exhList"
                                :key="item.id"
                                :label="item.exhibitionName"
                                :value="item.id">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>

                        <el-table-column prop="parentId" label="分类名称">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.parentId"  placeholder="请选择">
                              <el-option
                                v-for="item in comList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"  v-if="item.type == editFormVo.typeId && item.status == 0 && item.exhibitionId == scope.row.exhibitionId">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>


                        <el-table-column  label="操作">
                          <template slot-scope="scope">
                            <el-button  type="danger" @click="delcenZh(scope)">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-button  style="padding-bottom: 10px;  margin-bottom: 20px; margin-left: 140px;margin-top: 10px;" type="primary" @click="addZh">添加</el-button>
                    </el-form>
                  </div>

                  <el-form-item label="是否送餐" prop="isDelivery" v-if="editFormVo.typeId==3">
                    <el-radio v-model="editFormVo.isDelivery" label=0>否</el-radio>
                    <el-radio v-model="editFormVo.isDelivery" label=1>是</el-radio>
                  </el-form-item>

                  <el-form-item label="说明" prop="intro">
                    <el-input placeholder="说明" size="small" style="width: 400px;" v-model="editFormVo.intro"></el-input>
                  </el-form-item>

                  <el-form-item label="服务方" prop="commoditySer">
                    <el-input placeholder="服务方" size="small" style="width: 400px;" v-model="editFormVo.commoditySer"></el-input>
                  </el-form-item>

                  <div style="padding-bottom: 10px; width: 100%; margin-bottom: 13px; border-bottom: 2px solid;color: #333333">
                    <h1>联系方式</h1>
                  </div>
                  <el-form>
                    <el-table :data="editFormVo.commHotlines" style="width: 50%; margin-left: 140px">
                      <el-table-column prop="name" label="联系人">
                        <template slot-scope="scope">
                          <el-input placeholder="请输入联系人" v-model="scope.row.name"></el-input>
                        </template>
                      </el-table-column>

                      <el-table-column prop="phone" label="联系电话">
                        <template slot-scope="scope">
                          <el-input placeholder="请输入联系电话" v-model="scope.row.phone"></el-input>
                        </template>
                      </el-table-column>

                      <el-table-column  label="操作">
                        <template slot-scope="scope">
                          <el-button  type="danger" @click="delcen(scope)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-button  style="padding-bottom: 10px;  margin-bottom: 20px; margin-left: 140px;margin-top: 10px;" type="primary" @click="addcen">添加</el-button>
                  </el-form>

                  <div style="padding-bottom: 10px; width: 100%; margin-bottom: 13px; border-bottom: 2px solid;color: #333333"  v-if="editFormVo.typeId==3 || editFormVo.typeId==2">
                    <h1>订单规则设置</h1>
                  </div>
                  <el-form-item label="下单限制" prop="restric" v-if="editFormVo.typeId==3">
                    <el-radio v-model="editFormVo.restric" label="0">否</el-radio>
                    <el-radio v-model="editFormVo.restric" label="1">是
                      <el-time-picker
                        v-model="resDate"
                        format="HH:mm:ss"
                        value-format="HH:mm:ss"
                        placeholder="任意时间点">
                      </el-time-picker>
                    </el-radio>前，可订次日餐量
                  </el-form-item>

                  <el-form-item label="使用天数" v-if="editFormVo.typeId==2">
                    <a>最少需使用</a>  <el-input type="number" v-model="editFormVo.minDay" :min="1" style="width: 100px"></el-input>天，
                    <a>最多可使用</a>  <el-input type="number" v-model="editFormVo.maxDay" :min="1" style="width: 100px"></el-input>天
                  </el-form-item>

                  <div style="padding-bottom: 10px; width: 100%; margin-bottom: 13px; border-bottom: 2px solid;color: #333333">
                    <h1>价格&库存设置</h1>
                  </div>
                  <el-form-item label="库存" prop="amount">
                    <el-input placeholder="库存" type="number" :min="1" size="small" style="width: 400px;" v-model="editFormVo.amount"></el-input>
                  </el-form-item>
                  <el-form-item label="剩余库存" prop="residue">
                    <el-input placeholder="库存" type="number" :min="1" size="small" style="width: 400px;" v-model="editFormVo.residue"></el-input>
                  </el-form-item>
                  <el-form-item label="价格" prop="sellingPrice">
                    <el-input placeholder="价格" type="number" :min="1" size="small" style="width: 400px;" v-model="editFormVo.sellingPrice"></el-input>
                  </el-form-item>
                  <el-form-item label="价格单位" prop="sellingPriceType">
                    <el-input placeholder="价格单位" size="small" style="width: 400px;" v-model="editFormVo.sellingPriceType"></el-input>
                  </el-form-item>
                  <el-form-item label="押金" prop="cashPledge" v-if="editFormVo.typeId == 2 || editFormVo.typeId == 4">
                    <el-input placeholder="押金"  type="number" oninput="if (value < 0) value=0" size="small" style="width: 400px;" v-model="editFormVo.cashPledge"></el-input>
                  </el-form-item>

                  <el-form-item label="最小购买数量" prop="buyMin">
                    <el-input placeholder="最小购买数量" type="number" oninput="if (value < 0) value=0" size="small" style="width: 400px;" v-model="editFormVo.buyMin"></el-input>
                  </el-form-item>
<!--                  <el-form-item label="最大购买数量" prop="buyMax">-->
<!--                    <el-input placeholder="最大购买数量" type="number" :min="1" size="small" style="width: 400px;" v-model="editFormVo.buyMax"></el-input>-->
<!--                  </el-form-item>-->

                  <div style="padding-bottom: 10px; width: 100%; margin-bottom: 13px; border-bottom: 2px solid;color: #333333">
                    <h1>营销配置</h1>
                  </div>
                  <el-form-item label="商品排序" prop="sort">
                    <el-input placeholder="商品排序" type="number" size="small" style="width: 400px;" v-model="editFormVo.sort"></el-input>
                  </el-form-item>
                  <el-form-item label="是否推荐到首页" prop="isRecommend">
                    <el-radio v-model="editFormVo.isRecommend" label="0">否</el-radio>
                    <el-radio v-model="editFormVo.isRecommend" label="1">是
                      <el-input  type="number" :min="1" size="small" style="width: 100px;" v-model="editFormVo.recommendSort"></el-input>1-100，数值越大排名越高
                    </el-radio>
                  </el-form-item>

                  <el-form-item label="封面图" prop="coverImage">
                    <el-upload
                      class="avatar-uploader"
                      :action="this.host+'/fileUpload/ossBatch'"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccessCoverImage"
                      :before-upload="beforeAvatarUpload">
                      <img v-if="editFormVo.coverImage" :src="editFormVo.coverImage" class="avatar" width="200">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <div slot="tip" class="el-upload__tip">建议上传尺寸 300 * 300</div>
                    </el-upload>
                  </el-form-item>

                  <el-form-item label="介绍图" prop="image">
                    <el-upload
                      class="avatar-uploader"
                      :action="this.host+'/fileUpload/ossBatch'"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccessImage"
                      :before-upload="beforeAvatarUpload">
                      <img v-if="editFormVo.image" :src="editFormVo.image" class="avatar" width="200">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <div slot="tip" class="el-upload__tip">建议上传尺寸 1125 * 1125</div>
                    </el-upload>
                  </el-form-item>

                  <el-form-item label="注意事项" prop="notice">
                    <wangeditor :catchData="catchDatan" class="catchData margin-top" ref="childn"></wangeditor>
                  </el-form-item>


                  <el-form-item label="服务承诺" prop="pledge">
                    <wangeditor :catchData="catchDatas" class="catchData margin-top" ref="childs"></wangeditor>
                  </el-form-item>


                  <el-form-item label="产品详情" prop="details">
                    <wangeditor :catchData="catchData" class="catchData margin-top" ref="child"></wangeditor>
                  </el-form-item>


                    <el-form-item>
                        <div style="text-align: center;" >
                          <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editFormVo')">保存</el-button>
                        </div>
                    </el-form-item>

                </el-form>

            </el-main>
        </el-container>
    </div>
</template>


<script>


import {qryCommodityList, upShop,addShop} from '../../api/lotteryApi'
import {qryExhibitionList} from '../../api/courseApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import wangeditor from '../../components/wangeditor';


export default {
  name: "commodityEdit",
  data() {
    return {
      title:'添加',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      editableTabsValue: null,
      listData:[],
      resDate:'',
      isRecommend:'',
      exId:'',
      editFormVo:{
        id:'',
        name:'',
        exhibitionId:'',
        typeId:'',
        parentId:'',
        isDelivery:'',
        intro:'',
        commoditySer:'',
        commHotlines:[],
        restric:'',
        minDay:'1',
        maxDay:'1',
        isRefund:'',
        amount:'',
        sellingPrice:'',
        sellingPriceType:'',
        cashPledge:0,
        sort:'',
        isRecommend:'',
        coverImage:'',
        image:'',
        pledge:'',
        details:'',
        recommendSort:'',
        notice:'',
        buyMin:'',
        zhList:[],
      },
      // rules表单验证
      editFormRules: {
        typeId: [
          { required: true, message: '请选择大类', trigger: 'blur' }
        ],
        exhibitionId: [
          { required: true, message: '请选择展会', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        parentId: [
          { required: true, message: '请选择分类', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请输入商品库存', trigger: 'blur' }
        ],
        sellingPrice: [
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        sellingPriceType: [
          { required: true, message: '请输入价格单位', trigger: 'blur' }
        ],
        coverImage: [
          { required: true, message: '请选择封面图', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '请选择介绍图', trigger: 'blur' }
        ],
        cashPledge: [
          { required: true, message: '请输入押金', trigger: 'blur' }
        ],
        residue: [
          { required: true, message: '请输入剩余库存', trigger: 'blur' }
        ],
      },
      exhList:[],
      comList:[],
      typeSelect:[{"name":"服务类","value":"1"},
        {"name":"工程类","value":"2"},
        {"name":"餐饮类","value":"3"},
        {"name":"租赁类","value":"4"}],



    }
  },
  mounted() {
    if(this.$route.query.commodityInfo){
      console.log("this.$route.query.commodityInfo",this.$route.query.commodityInfo)
      let _this = this;
      setTimeout(() => {
        _this.$refs.child.echo(this.editFormVo.details);
      }, 0)

      let _thiss = this;
      setTimeout(() => {
        _thiss.$refs.childs.echo(this.editFormVo.pledge);
      }, 0)

      let _thisn = this;
      setTimeout(() => {
        _thisn.$refs.childn.echo(this.editFormVo.notice);
      }, 0)


      this.editFormVo = this.$route.query.commodityInfo;
      this.editFormVo.typeId = this.$route.query.typeId;
      this.editFormVo.isDelivery = this.editFormVo.isDelivery.toString();
      this.editFormVo.isRefund = this.editFormVo.isRefund.toString();
      this.editFormVo.isRecommend = this.editFormVo.isRecommend.toString();
      if (this.editFormVo.restric != '0'){
        this.resDate = this.editFormVo.restric;
        this.editFormVo.restric = '1';
      }
      this.$forceUpdate();
    }
    this.exId = this.$route.query.exId;
  },
  created(){
    this.tableList();
  },
  methods:{
    tableList(){

      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
      })

      qryCommodityList({pageSize:1000}).then(res => {
        this.comList = res.data.list;
      })
      this.$forceUpdate();
    },

    handleAvatarSuccessImage(res) {
      this.editFormVo.image = res.data;
    },

    handleAvatarSuccessCoverImage(res) {
      this.editFormVo.coverImage = res.data;
    },

    catchData(val){
      this.editFormVo.details = val;
    },

    catchDatas(val){
      this.editFormVo.pledge = val;
    },

    catchDatan(val){
      this.editFormVo.notice = val;
    },

    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },

    clearParId(){
      this.editFormVo.parentId = null;
      this.editFormVo.zhList=[];
    },

    //添加内容
    addcen(){
      this.editFormVo.commHotlines.push({
        name:'',
        phone:''
      })
    },

    delcen(e){
      console.log(e.$index,e,this.editFormVo.commHotlines)
      // delete this.editFormVo.commHotlines[]
      this.editFormVo.commHotlines.splice(e.$index,1);
      // this.editFormVo.commHotlines = this.editFormVo.commHotlines.map((item)=>{
      //   return item
      // })
      // this.$forceUpdate()
    },


    //添加内容
    addZh(){
      this.editFormVo.zhList.push({
        exhibitionId:'',
        parentId:''
      })
    },

    delcenZh(e){
      this.editFormVo.zhList.splice(e.$index,1);
    },



    // 编辑、添加提交方法
    submitForm(editData) {
      // if (this.editFormVo.commHotlines.length == 0){
      //   this.$message.error('请填写联系方式！')
      //   return;
      // }
      if (this.editFormVo.details == '<p><br/></p>'){
        this.$message.error('请填写产品详情！')
        return;

      }
      if(this.editFormVo.id==''){
        if (this.editFormVo.zhList.length == 0){
          this.$message.error('请填写展会信息！')
          return;
        }
      }
      console.log("this.editFormVo",this.editFormVo)
      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.editFormVo.typeId == 3 && this.editFormVo.restric != 0){
            this.editFormVo.restric = this.resDate;
          }else {
            this.editFormVo.restric = '0';
          }

          if (this.editFormVo.isRecommend == 0){
            this.editFormVo.recommendSort = '';
          }
          if(this.editFormVo.id!=''){
            upShop(this.editFormVo).then(res =>{
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.$router.push({ path: '/lottery/signInLogList',query:{exId:this.exId}})
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          } else{
            addShop(this.editFormVo)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.$router.push({ path: '/lottery/signInLogList',query:{exId:this.exId}})
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },



  },
  //分页组件
  components: {
    ElInputNumber,
    wangeditor,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lottery/commodityEdit.vue